module.exports = __webpack_public_path__ + "img/how-1.da502e95.png";